import { render } from "./SystemAlerts.vue?vue&type=template&id=63f0d08a&scoped=true"
import script from "./SystemAlerts.vue?vue&type=script&lang=js"
export * from "./SystemAlerts.vue?vue&type=script&lang=js"

import "./SystemAlerts.vue?vue&type=style&index=0&id=63f0d08a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f0d08a"]])

export default __exports__